/**
 * 黄江 on 2017/7/29
 * 描述：
 */
import Vue from 'vue'
Vue.filter("formatDateTime", function(value) {   //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  if(!value){
    return ''
  }
  const dt=new Date(value);
  const year=dt.getFullYear();
  const month=dt.getMonth()+1;
  const date=dt.getDate();
  const hour =  dt.getHours(); //小时
  const minu =  dt.getMinutes(); //分
  const second =  dt.getSeconds(); //秒
  return year+"-"+month+"-"+date+" "+hour+":"+minu+":"+second;
});
Vue.filter("formatDate", function(value) {   //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
    if(!value){
      return ''
    }
    const dt=new Date(value);
    const year=dt.getFullYear();
    const month=dt.getMonth()+1;
    const date=dt.getDate();
    return year+"-"+month+"-"+date;
});
Vue.filter("status", function(value) {
  const statusArr = {
    'val0':'禁用',
    'val1':'启用',
  }
  return statusArr[`val${value}`]
});
Vue.filter("toFixed2", function(value) {
  return parseFloat(value||0).toFixed(2)
});



// WEBPACK FOOTER //
// ./src/assets/js/filters.js